import { Dialpad } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconDialpad12Line = createIcon(Dialpad, 12, "Line");
export const IconDialpad16Line = createIcon(Dialpad, 16, "Line");
export const IconDialpad20Line = createIcon(Dialpad, 20, "Line");
export const IconDialpad24Line = createIcon(Dialpad, 24, "Line");
export const IconDialpad32Line = createIcon(Dialpad, 32, "Line");
export const IconDialpad48Line = createIcon(Dialpad, 48, "Line");
export const IconDialpad64Line = createIcon(Dialpad, 64, "Line");
